import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { documentTypeEnum, messageTypeEnum } from '../../enum';
import {
    getCurrentDate,
    addDayToDate,
    getCasaMatriz,
    IsNotNullOrEmptyOrUndefined
} from '../../util';
import {
    postFacturaPorEmisor, postTiquetePorEmisor, clearErrors, setError, postNotaCreditoPorEmisor,
    postNotaDebitoPorEmisor, postFacturaCompraPorEmisor,
} from '../../actions';
import InputField from "../nuevoDocumento/InputField";

const BuscarDocumentos = (props) => {
    const { docType, token, emisor, numeroPagina, tamanoPagina } = props;
    const [fechaInicio, setFechaInicio] = useState(addDayToDate(getCurrentDate(), -30));
    const [fechaFin, setFechaFin] = useState(addDayToDate(getCurrentDate(), + 1))

    useEffect(() => {
        props.clearErrors();

        if (token !== null && emisor !== null && fechaInicio && fechaFin) {

            let request = {
                Identificacion: emisor.Identificacion.Numero,
                CasaMatriz: getCasaMatriz(emisor.usuario),
                FechaInicio: fechaInicio,
                FechaFin: fechaFin,
                NumeroPagina: numeroPagina,
                TamanoPagina: tamanoPagina
            };

            loadDocumentos(request);

        }

    }, [numeroPagina]);

    const loadDocumentos = (request) => {

        switch (docType) {
            case documentTypeEnum.Factura:
                props.postFacturaPorEmisor(token.access_token, request);
                break;
            case documentTypeEnum.Tiquete:
                props.postTiquetePorEmisor(token.access_token, request);
                break;
            case documentTypeEnum.NotaCredito:
                props.postNotaCreditoPorEmisor(token.access_token, request);
                break;
            case documentTypeEnum.NotaDebito:
                props.postNotaDebitoPorEmisor(token.access_token, request);
                break;
            case documentTypeEnum.FacturaCompra:
                props.postFacturaCompraPorEmisor(token.access_token, request);
                break;
        }
    }

    const setFechaInicioFormat = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setFechaInicio(fechaString);
        }
    };

    const setFechaFinFormat = (value) => {
        if (IsNotNullOrEmptyOrUndefined(value)) {
            let fecha = new Date(value);
            let fechaString = fecha.getUTCFullYear() + "-" + (fecha.getUTCMonth() + 1) + "-" + fecha.getDate();
            setFechaFin(fechaString);
        }
    };

    const listarConfirmados = () => {
        let fecha1 = new Date(fechaInicio);
        let fecha2 = new Date(fechaFin);
        if (fecha1 > fecha2) {
            props.setError("El rango de fechas digitado no es válido", messageTypeEnum.error);
        } else {
            let request = {
                Identificacion: emisor.Identificacion.Numero,
                CasaMatriz: getCasaMatriz(emisor.usuario),
                FechaInicio: fecha1,
                FechaFin: fecha2,
                NumeroPagina: numeroPagina,
                TamanoPagina: tamanoPagina
            };

            loadDocumentos(request);
        }
    };

    return (<div className="ui segment grid">
        <div className="doubling three column centered row mb-1">
            <div className="ui form column">
                <div className="row">
                    <InputField
                        label="Fecha desde"
                        value={fechaInicio}
                        type="datePicker"
                        placeholder="DD-MM-YYYY"
                        onChange={(e) => setFechaInicioFormat(e?._d)}
                    />
                </div>
            </div>
            <div className="ui form column">
                <div className="row">
                    <InputField
                        label="Fecha hasta"
                        value={fechaFin}
                        type="datePicker"
                        placeholder="DD-MM-YYYY"
                        onChange={(e) => setFechaFinFormat(e?._d)}
                    />
                </div>
            </div>
            <div className="column">
                <input type="submit" className="ui but blue inline button custom-file-input" onClick={() => listarConfirmados()} value="Listar documentos" />
            </div>
        </div>
    </div>)
}

const mapStateToProps = (state) => {
    return {
        loginState: state.loginState,
    };
};

export default connect(mapStateToProps,
    {
        postFacturaPorEmisor,
        setError,
        clearErrors,
        postTiquetePorEmisor,
        postNotaCreditoPorEmisor,
        postNotaDebitoPorEmisor,
        postFacturaCompraPorEmisor,
    })(BuscarDocumentos);